import React, { useState } from "react";
import "./filterBox.css";

const FilterBox = ({ setFilter, setIsPopupOpen, filter, sub }) => {
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedType, setType] = useState("");
  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    const isChecked = e.target.checked;
    console.log(isChecked)
    if (isChecked) {
        setSelectedSubjects(prevSelected => [...prevSelected, value]);
    } else {
        setSelectedSubjects(prevSelected => prevSelected.filter(subject => subject !== value));
    }
  };

  const handleApply = () => {
    setFilter((prev) => ({
      ...prev,
      subjects: selectedSubjects,
      type: selectedType,
    }));
  }
  return (
    <>
      <div
        style={{
          backgroundColor: "white",
          width: "400px",
          border: "2px solid #F99933",
          borderRadius: "5px",
        }}
      >
        <div className="filterbox">
          <img src="/ContentM_images/Vector.svg"/>
          <h5 className="mb-2 filter_Text">Filter</h5>
        </div>
        <div className="py-2 d-flex justify-content-between">
        <div className="col-5 filter_subj_box">
          <h5 className="mb-2 filter_first_heading_ass filterHeading">
            SUBJECT
          </h5>
          <div className=" gap-2 px-3 d-flex align-item-center flex-column subject_subbox">
          <div>
            {sub.map((subject) => (
                <div className="" key={subject.id}>
                    <input
                        className="form-check-input"
                        name="filter"
                        type="checkbox"
                        value={subject.id}
                        id={subject.id}
                        checked={selectedSubjects.includes(subject.id) }
                        onChange={handleCheckboxChange}
                    />
                    <label htmlFor={subject.id}>
                        {subject.name}
                    </label>
                </div>
            ))}
        </div>
          </div>
        </div>
        <div className="col-7 p-0 filter_time_box">
          <h5 className="mb-2 filter_first_heading filterHeading">TYPE</h5>
          <div className=" gap-2 px-3 d-flex align-item-center flex-column subject_subbox  ">
            <div className="">
              <input
                class="form-check-input"
                type="checkbox"
                value="Query"
                id="flexCheckDefault"
                checked={selectedType === "Query"}
                onChange={(e) =>
                  // setFilter((prev) => ({ ...prev, type: e.target.value }))
                  setType( e.target.value )
                }
              />
              <span>Query</span>
            </div>
            <div className="">
              <input
                class="form-check-input"
                type="checkbox"
                value="Community"
                id="flexCheckDefault"
                checked={selectedType === "Community"}
                onChange={(e) =>
                  // setFilter((prev) => ({ ...prev, type: e.target.value }))
                  setType( e.target.value )
                }
              />
              <span>Community</span>
            </div>
            {/* <div className="">
              <input
                class="form-check-input"
                type="checkbox"
                value="General"
                id="flexCheckDefault"
                checked={selectedType === "General"}
                onChange={(e) =>
                  // setFilter((prev) => ({ ...prev, type: e.target.value }))
                  setType( e.target.value )
                }
              />
              <span>General</span>
            </div> */}
          </div>
          <div
            style={{
              position:"absolute",
              bottom:"0",
              right:"10px"
            }}
            className="d-flex gap-2"
          >
            <button
              style={{
                width: "65px",
                height: "26px",
                borderRadius: "6px",
                backgroundColor: "#FFFFFF",
                color: "#F77F00",
                border: "none",
                textAlign: "center",
                fontSize: "12px",
                border: "2px solid #F77F00",
                fontWeight: "600",
              }}
              onClick={() => {
                setFilter((prev) => ({
                  ...prev,
                  subjects: [],
                  type: null,
                  clicked: !filter.clicked,
                }));
                setIsPopupOpen((prev) => !prev);
              }}
            >
              Clear
            </button>
            <button
              style={{
                width: "65px",
                height: "26px",
                borderRadius: "6px",
                backgroundColor: "#F77F00",
                border: "none",
                color: "white",
                textAlign: "center",
                fontSize: "12px",
                fontWeight: "600",
              }}
              onClick={() => {
                setFilter((prev) => ({ ...prev, clicked: !filter.clicked }));
                setIsPopupOpen((prev) => !prev);
                handleApply();
              }}
            >
              Apply
            </button>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default FilterBox;
